// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__hLYmW","topBottomGutter":"Layout_topBottomGutter__1ldwK"};